import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import { SHOPS_MAP_BLOCK_DATA_SOURCE, ShopsMapBlockDataSource } from './shops-map-block-view-model';
import { ShopsMapBlockPreviewDataSource } from './shops-map-block-preview-data-source';
import { ShopsMapBlockStoreDataSource } from './shops-map-block-store-data-source';

export function provideShopsMapBlockDataSource(): Provider[] {
  return [
    ShopsMapBlockStoreDataSource,
    ShopsMapBlockPreviewDataSource,
    {
      provide: SHOPS_MAP_BLOCK_DATA_SOURCE,
      useFactory: (): ShopsMapBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(ShopsMapBlockPreviewDataSource)
          : inject(ShopsMapBlockStoreDataSource);
      },
    },
  ];
}
